export const kycStatuses = {
  ALL: {
    statusDesc: "All",
    statusColor: "primary",
  },
  FULL_KYC: {
    statusDesc: "Full KYC",
    statusColor: "success",
  },
  PARTIAL_KYC: {
    statusDesc: "Partial KYC",
    statusColor: "secondary",
  },
  REJECTED: {
    statusDesc: "Rejected",
    statusColor: "danger",
  },
};

export const LIMITS_STORAGE_NAME = "active-limits-list";

export const GOOGLE_MAPS_KEY =
  process.env.GOOGLE_MAPS_KEY || "AIzaSyCVVdespDBOlwIAIPr6EdrgzuIpxEKDKVQ";

export const MAX_FILE_SIZE_IN_BYTES = 1 * 1024 * 1024;
